'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.init = init;

var _swiper = require('swiper/js/swiper.esm');

var _utils = require('../utils');

var _helpers = require('./_helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');

  makeCarousel();

  function makeCarousel() {
    var _breakpoints;

    (0, _helpers.initialiseSwiper)(swiperContainer, {
      loop: true,
      watchSlidesProgress: true,
      slidesPerView: 1.6,
      centeredSlides: true,
      initialSlide: 1,
      spaceBetween: 0,
      speed: 500,
      slideClass: context.className + '_Slide',
      autoplay: {
        delay: 3000
      },
      breakpoints: (_breakpoints = {}, (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.sm, {
        slidesPerView: 2.4
      }), (0, _defineProperty3.default)(_breakpoints, _utils.mediaBreakpoints.md, {
        slidesPerView: 4.3
      }), _breakpoints),
      navigation: {
        nextEl: '.' + context.className + '_Next',
        prevEl: '.' + context.className + '_Prev'
      }
    }, [_swiper.Navigation, _swiper.Autoplay]);
  }
}